import z from 'zod'
import { createFileRoute } from '@tanstack/react-router'
import { Referrals } from '@/features/referrals'
import { requireActiveSubscription } from '@/lib/middleware'

const referralsSearchSchema = z.object({
  page: z.number().optional().catch(1),
  pageSize: z.number().optional().catch(10),
  search: z.string().optional().catch(''),
  status: z
    .array(
      z.enum(['received', 'screening', 'accepted', 'declined', 'waitlisted'])
    )
    .optional()
    .catch([]),
  sortBy: z.string().optional(),
  sortOrder: z.enum(['asc', 'desc']).optional(),
})

export const Route = createFileRoute(
  '/_authenticated/_organization/referrals/'
)({
  beforeLoad: async () => requireActiveSubscription(),
  validateSearch: referralsSearchSchema,
  component: Referrals,
})
